
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

export const useSupabaseAuth = () => {
    const [user, setUser] = useState(null);
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const signOut = async () => {
        localStorage.removeItem('last_visited_path');
        navigate('/login');
        await supabase.auth.signOut();
    };

    useEffect(() => {
        // Handle "Stay logged in" logic
        const isNewSession = !sessionStorage.getItem('sevenhats_session_active');
        const stayLoggedIn = localStorage.getItem('sevenhats_stay_logged_in') !== 'false';

        if (isNewSession) {
            sessionStorage.setItem('sevenhats_session_active', 'true');
            if (!stayLoggedIn) {
                 supabase.auth.signOut().finally(() => {
                     setLoading(false);
                 });
                 return;
            }
        }

        const fetchUser = async () => {
            try {
                const { data, error } = await supabase.auth.getSession();
                if (data && data.session) {
                    setSession(data.session);
                    setUser(data.session.user);
                }
            } catch (error) {
                console.error("Error fetching user:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();

        const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session);
            setUser(session?.user ?? null);
            setLoading(false);
        });

        return () => {
            authListener?.subscription.unsubscribe();
        };
    }, []);

    return { user, session, loading, signOut };
};
